import React, { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { useTheme } from "../../context/ThemeContext";
import { useAuth } from "../../context/AuthContext";
import { clinicalTrialMenuItems } from "../../modules/clinical-trial/routes";
import AppFooter from "../shared-layout/AppFooter";

const MainLayout: React.FC = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const authService = useAuth();

  const menuMapping: Record<string, any> = {
    "/clinical-trial": clinicalTrialMenuItems,
  };

  const activeMenuItems = useMemo(() => {
    const path = Object.keys(menuMapping).find((basePath) =>
      location.pathname.startsWith(basePath)
    );
    const items = menuMapping[path || ""] || [];
    return items.filter((item: any) => {
      if (!item.permission || item.permission.length === 0) return true;
      return authService.hasPermission(item.permission);
    });
  }, [location.pathname, authService]);

  return (
    /**
     * 3-row grid that fills the viewport height and DISABLES page scrolling.
     * Only the middle row (content) is scrollable.
     */
    <div className="grid h-screen grid-rows-[auto,1fr,auto] overflow-hidden w-full">
      {/* Row 1: fixed header */}
      <Topbar />

      {/* Row 2: content row — owns the scroll */}
      <div
        className={`flex min-h-0 gap-4 overflow-hidden ${
          theme === "night" ? "bg-gray-700 text-gray-50" : "bg-primary-100"
        }`}
      >
        <Sidebar menuItems={activeMenuItems} />

        {/* Right pane must be the *only* scroller */}
        <div
          className={`flex-1 min-h-0 overflow-y-auto overflow-x-hidden rounded-tl-3xl ${
            theme === "night" ? "bg-gray-700 text-gray-50" : "bg-gray-50"
          }`}
        >
          <Outlet />
        </div>
      </div>

      <AppFooter />
      {/* You can also pass props or force modal, e.g.:
          <AppFooter forceModal productionYear={2024} orgName="Your Org" />
      */}
    </div>
  );
};

export default MainLayout;
